module.exports = __webpack_public_path__ + "static/media/8C-0@3x.ee796430.png";